exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, "body{font-family:'Fira Sans', sans-serif !important}\n", "",{"version":3,"sources":["/home/admin/alg-onb-workspace/alg-truffe-fe/src/app.scss"],"names":[],"mappings":"AAGA,KACI,8CAA+C","file":"app.scss","sourcesContent":["@import 'commons/styles/variables';\n\n\nbody{\n    font-family: 'Fira Sans', sans-serif !important;\n}"],"sourceRoot":""}]);

